export default __webpack_public_path__ + "static/enterprise-voice-enablement-2ee63d65113bb0e2db0a10cda348baf7.jpeg";